import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import {getRecordInsertingPosition } from "./CopyAndPaste";
import datatypes, { RECORD_TYPE,DATA_TYPE, FIELD_TYPE } from "../../../constants/datatypes";
import { t } from "i18next";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from "../../../utils/utilFunctions";

const NewRecord = ({ toggle, openModal }) => {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const {rightTree} = useSelector(state=>state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const [showModal,setShowModal] = useState(false);
  const content = t('BOX_LIKE_TO_PLACE_REC_INSIDE_CURR_REC_OR_DIRECTLY_AFTER').split(`\\n`).join("<br/>")
  const contentRef = useRef();
  const dispatch = useDispatch();

  const handleNewRecord =(isInside)=>{
    
    let nestedLevels = selectedNode.key.split('-');
    nestedLevels = nestedLevels.splice(1);
    const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);

    // Function For Getting New Record Title and Key
    const getNewRecordData=(data,key,isInside)=>{
      
      const title = getNewRecordName(rightTree.tree);

      //If it is empty so it will make first node with 'ib-0' key
      if(!data.length){
        return {key:`${key}-0`,title}
      }

      let placingPosition;
      let newRecordKey;
      
      const details = templateHeader?.FILETYPE === "JSON" && isInside ? {index: 0, key: selectedNode?.key + "-0" } : getRecordInsertingPosition(data,selectedNode,isInside, parentScreen, currentTab);
      placingPosition=details.index;
      newRecordKey = details.key;


      return {key:newRecordKey,title,placingPosition:placingPosition} ;
    }
    

    // Inserting New Node Object in Tree Data (Recursive Function);
    function insertNodeInNestedTree (translatedData,nestedLevels,isInside){
      const level = isInside?0:1;
      if(nestedLevels.length==level){

        const {children,key} = translatedData;
        const newRecordDetails = children?getNewRecordData(children,key,isInside):getNewRecordData(translatedData,'ib',isInside);

        const newNode = {
          key: newRecordDetails.key,
          title: newRecordDetails.title,
          nodeId: genKey(newRecordDetails.title),
          alternateNodeId: genKey(newRecordDetails.title),
          ICON_DISPLAY: DATA_TYPE[templateHeader.FILETYPE]?.record?.icon,
          type: DATA_TYPE[templateHeader.FILETYPE]?.record?.icon,
          TYPE: newRecordDetails.title,
          treeType: rightTree.currentTab,
          children: [],
          ...DATA_TYPE[templateHeader.FILETYPE]?.record?.data
        };
        if (parentScreen === "outbound") {
          newNode["EDIT_RULE"] = [
            {
              "TYPE": "RECORD_RULE"
            }
          ];
          newNode["LOOP"] = "SINGLE";
        }

        const translatedDataArray= children ? translatedData.children : translatedData;
        translatedDataArray.splice(newRecordDetails.placingPosition,0,newNode);
        dispatch(treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type:currentTab, 
          data:{...newNode}
        }));
        return;

      }

      const isArray = Array.isArray(translatedData);

      if(isArray){
        const nestedData = translatedData[[nestedLevels[0]]];
        const newNestedLevels = nestedLevels.splice(1);
        insertNodeInNestedTree(nestedData,newNestedLevels,isInside);
      }else{
        // const newNestedLevels = nestedLevels.splice(1);
        insertNodeInNestedTree(translatedData.children,nestedLevels,isInside);
      }
    }

    insertNodeInNestedTree(translatedData,nestedLevels,isInside);
    const updatedData = getUpdatedData(translatedData ,templateHeader?.FILETYPE,parentScreen,currentTab);
    dispatch(treeActions.setNewRightTreeTranslatedData({
      screen: parentScreen,
      type: currentTab, 
      data: updatedData
    }));
    toggle(prev=>null);
    setShowModal(false);
  }
  
  
  setTimeout(()=>{
    if(contentRef.current?.innerHTML=="")contentRef.current.innerHTML = content
  },0)
  
  
  const newRecordHandler =()=>{
    if(parentScreen==="outbound" && selectedNode.key.split("-").length===2){
      handleNewRecord(true)
      return;
    }
    else if(templateHeader.FILETYPE==="JSON" && selectedNode?.key=="ib-0-0"){
      handleNewRecord(true);
      return;
    }
    else if(!RECORD_TYPE[selectedNode.ICON_DISPLAY]&&openModal){
      handleNewRecord(false);
      return;
    }
    else if(selectedNode.key=="ib-0"&&currentTab!="body"&&openModal){
      handleNewRecord(true);
      return;
    }
    else{
      setShowModal(true);
    }
  }
  useEffect(()=>{
    if(openModal){
      newRecordHandler();
    }
  },[openModal])
  
  return(
    <Dialog open={showModal} maxWidth="xs" fullWidth>
      <DialogTitle className="dialog-header">
        <div className="title">
          {t("BOX_CONFIRM")}
        </div>
      </DialogTitle>
      <DialogContent className="dialog-content" dividers>
          <div ref={contentRef} ></div>
      </DialogContent>
      <DialogActions>
        <Button size='small' variant="outlined" color="primary" onClick={()=>handleNewRecord(true)} >
          {t("BTN_YES")}
        </Button>
        <Button size='small' variant="outlined" color="primary" onClick={()=>handleNewRecord(false)} >
          {t("BTN_NO")}
        </Button>
        <Button size='small' variant="outlined" color="primary" onClick={()=>{
          toggle(null);
          setShowModal(false);
          }} >
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default NewRecord;

export const getUpdatedData =(translatedData,dataType,screenType,currentTab)=>{
  const data = cloneDeep(translatedData);
  const key= screenType ?  {inbound: "ib", outbound: {header: "obh", body: "ob", trailer: "obt"}[currentTab], workflow: "wf"}[screenType] : 'ib';
  const addBeginningAndEnd  = dataType === "FIXED_LENGTH" || (dataType === "DELIM_FLD_ID" && currentTab === "header") || false;

  const getNewKeys=(data,key,isParentFieldGroup)=>{
    let fieldNumber = dataType === "EDI" ? (isParentFieldGroup ? 1 : 0) : 1;
    let beginNumber = 1;
    let ifId = "";
    data.forEach((ele,idx)=>{
      const newKey =`${key}-${idx}`;
      if(FIELD_TYPE[ele?.ICON_DISPLAY] || ['FIELD_GROUP','REPEATING_FIELD_GROUP'].includes(ele?.ICON_DISPLAY)){
        const tempFieldNumber = (["EDI", "HL7"].includes(dataType) && ele?.ICON_DISPLAY?.includes('FIELD_GROUP')) || FIELD_TYPE[ele?.ICON_DISPLAY] ? fieldNumber++ : undefined;
        // console.log(tempFieldNumber);
        data[idx]={
          ...data[idx],
          key:newKey,
          fieldNumber:`${tempFieldNumber || ""}`,
          children:ele?.children ? ele.children : [],
          ...((dataType === "JSON" || dataType === "XML") ? {GUI_XML_SORT_ORDER: `${idx + 1}`} : {}),
        }
        if(addBeginningAndEnd){ //Fixed Length Data Type Begin and End.
          data[idx].BEGIN = Number(beginNumber);
          data[idx].END = !data[idx]?.LENGTH ? '' : Number(beginNumber) + (Number(data[idx]?.LENGTH) || 0) - 1;
          beginNumber += !data[idx]?.LENGTH ? 0 : (Number(data[idx]?.LENGTH) || 0);
          
        }
      }
      else{
        if (ele?.ICON_DISPLAY === "CONDITION_IF") ifId = genKey();
        data[idx]={
          ...data[idx],
          key:newKey,
          children:ele?.children ? ele.children : [],
          nodeId: ["CONDITIONAL_IF", "CONDITIONAL_ELSE"].includes(ele?.ICON_DISPLAY) ? ifId : data[idx]?.nodeId,
          ...((dataType === "JSON" || dataType === "XML") ? {GUI_XML_SORT_ORDER: `${idx + 1}`} : {}),
        }
        if(ele?.ICON_DISPLAY !== "CONDITION_IF" || data?.[idx + 1]?.ICON_DISPLAY !== "CONDITION_ELSE") ifId = "";
      }
      if(ele?.children?.length) data[idx].isLeaf = false;
      else data[idx].isLeaf = true;


      if(ele?.children?.length>0){
        getNewKeys(ele.children,newKey,ele?.ICON_DISPLAY?.includes('FIELD_GROUP'));
      }

    })
  }
  getNewKeys(data,key);
  // console.log(data);
  return data;
}

export const getNewRecordName =(tree , isOutbound)=>{

  ////--------------------Function to Get New Record New On Every Record Creation------------------------////

  const data = cloneDeep(tree);
  const body = data.body.translatedData;
  const header = data.header.translatedData;
  const trailer = data.trailer.translatedData;
  let titleNumber =0;


  const getTitleName=(data)=>{

    data.forEach((ele,idx)=>{
      if(RECORD_TYPE[ele?.ICON_DISPLAY]&&ele?.title?.startsWith(t('UNNAMED'))){

        let title = isOutbound ? ele?.title?.replace(`${t("LBL_RECORD")} `, "")  : ele.title;
        const indexOfUnderScore = title.indexOf('_');
        title = indexOfUnderScore >=0 ? title.slice(0,indexOfUnderScore) : title;
        const latestUnnamedRecord = + title.slice(t('UNNAMED').length);

        if(!isNaN(latestUnnamedRecord)){
          titleNumber = latestUnnamedRecord > titleNumber ? latestUnnamedRecord  : titleNumber;
        }

      }
      if(ele?.children?.length>0){
        getTitleName(ele.children);
      }
    })
  }

  getTitleName(body);
  getTitleName(header);
  getTitleName(trailer);

  return `${t('UNNAMED')}${Number(titleNumber)+1}`

}
